export class StorageFactory {

  protected clear(): void {
    localStorage.clear();
  }

  get(field: string): string | null {
    return localStorage.getItem(field);
  }

  set(field: string, value: any): void {
    localStorage.setItem(field, value);
  }

  delete(field: string): void {
    localStorage.removeItem(field);
  }

  setFlag(field: string, bool: boolean): void {
    this.set(field, bool);
  }

  getFlag(field: string): boolean {
    return this.get(field) === 'true';
  }

  setObject(field: string, obj: any): void {
    this.set(field, JSON.stringify(obj));
  }

  getObject(field: string): any {
    const result = JSON.parse(this.get(field) || 'null');
    if (result) {
      return result;
    } else {
      return false;
    }
  }

}
